import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Button, Input } from "reactstrap"
import { formatAddress } from "../utils";
import {useContracts} from "../libs/useMetaMaskWallet"

const TradingCard = (props) => {
  const contracts = useContracts()

  const { data } = props
  const [loading, setLoading] = useState(false)
  const [showMenu, setShowMenu] = useState(false)
  const [sellInput, showSellInput] = useState(false)
  const [price, setPrice] = useState("")
  const tradingApi = "https://nft.idexo.io"

  const sellToken = async () => {
    if (data.source.includes("avalanche")) {
      const res = await contracts.tradeAvalanche.openForSale(data.token_id, Number(price))
      if (res.status) {
        sellTokenApi(price)
      }
    } else if (data.source.includes("polygon")) {
      const res = await contracts.tradePolygon.openForSale(data.token_id, Number(price))
      if (res.status) {
        sellTokenApi(price)
      }
    }
  }

  const buyToken = async () => {
    if (data.source.includes("avalanche")) {
      const res = await contracts.tradeAvalanche.bid(data.token_id)
      console.log(res)
    } else if (data.source.includes("polygon")) {
      const res = await contracts.tradePolygon.bid(data.token_id)
      console.log(res)
    }
  }

  const closeForSaleToken = async () => {
    if (data.source.includes("avalanche")) {
      const res = await contracts.tradeAvalanche.closeForSale(data.token_id)
      if (res.status) {
        sellTokenApi("-1")
      }
    } else if (data.source.includes("polygon")) {
      const res = await contracts.tradePolygon.closeForSale(data.token_id)
      if (res.status) {
        sellTokenApi("-1")
      }
    }
  }

  const sellTokenApi = (price) => {
    fetch(tradingApi, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: localStorage.jwtToken
      },
      body: JSON.stringify({
        source: data.source,
        inserted: data.inserted,
        price
      })
    })
      .then(() => {
        setLoading()
      })
      .catch((error) => {
        console.log(error)
      })
  }

  return (
    <>
      {
        !showMenu
        ?
          <div className="card-item" key={1}>
            <div className="img-container">
              <img src={data.details.uri} alt={"card"} />
            </div>
            <div className="card-content-body">
              <p className="card-title">{data.details.name}</p>
              <p className="card-description">{data.details.description}</p>
              {data.accelerator && <p>Accelerator: {data.accelerator}</p>}
              {data.price && <p>Price: {data.price}</p>}
            </div>
            {/*<div className="card-content-footer">*/}
            {/*  <span>${data.details.attributes.communityRank}</span>*/}
            {/*  <span className="action-icon"><i className="fa fa-question" /></span>*/}
            {/*</div>*/}
            <div className="card-icon" onClick={() => setShowMenu(true)}>
              <i className="bx bx-dots-horizontal-rounded" />
            </div>
          </div>
        :
          <div className="card-item menu" key={2}>
            <div className="menu-header">
              <p className="title">{data.details.name}</p>
              <div>
                <p className="font-size-16 font-weight-semibold mb-2">{formatAddress(data.wallet)}</p>
                <span>{data.author}</span>
              </div>
            </div>
            <div className='menu-body'>
              <Link className="card-menu-item" to={`/nft/${data.token_id}`}>
                View collectible
              </Link>
              {props.buy &&
                (
                  <div className="card-menu-item" onClick={() => {}}>
                    Buy Now
                  </div>
                )
              }
              {props.sell &&
                (
                  <div className="card-menu-item" onClick={() => showSellInput(!sellInput)}>
                    Sell Now
                  </div>
                )
              }
              {props.closeForSale &&
                (
                  <div className="card-menu-item" onClick={closeForSaleToken}>
                    Close For Sale
                  </div>
                )
              }
            </div>
            <div className="card-icon" onClick={() => setShowMenu(false)}>
              <i className="bx bx-arrow-back" />
            </div>
            {sellInput &&
              <div className="sell-input mb-2 mx-2" style={{display: 'flex'}}>
                <Input
                  placeholder="Price"
                  value={price}
                  onChange={(e) => setPrice(e.target.value)}
                />
                <Button color="primary" onClick={sellToken} style={{marginLeft: 5}}>
                  Confirm
                </Button>
              </div>
            }
          </div>
      }
    </>
  )
}

export default TradingCard
